import React from 'react';


export default class AboutUsPage extends React.Component {
  render() {
    return (
      <div id="about-us-page" className="about-us-page content-wrapper">
        <div className="content">
          <h3>About Us</h3>
          <p>
            Once, there were two batchmates.
          </p>
          <p>
            Both taking up Computer Engineering in UP Diliman, they were first introduced to each other at a friend’s debut. Soon enough, they applied for the same organization.
          </p>
          <p>
            A shared passion for singing and a tad of peer pressure got them both into the same choir. Awitan, a choral competition for Engineering orgs, demanded long hours of rehearsal, which made them see each other more often.
          </p>
          <p>
            Jelo wanted to know Lorr better and did what a gentleman could do - he told Lorr he likes her and went straight to her mom to ask,
          </p>
          <p>
            “Pwede ko pong ligawan si Grace?”
          </p>
          <p>
            They spent the next eleven months having walks, eating lunches & dinners, talking, chatting online, attending more choir practices, riding the commute home, and the list goes on. Inseparable even, because they did almost everything together.
          </p>
          <p>
            On the 17th of November 2011, they finally exchanged “I love you”’s.
          </p>
          <p>
            With the blessing of their parents, Jelo proposed to Lorr after finishing his first Cobra Ironman 70.3 race on the 7th of August 2016.
          </p>
          <p>
            Two batchmates who became orgmates. Then choirmates, friends, and eventually lovers.
          </p>
          <p>
            Soon, they will be partners... forever.
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AboutUsPage/index.js